import React from "react";
import DynamicEditForm from "../../components/DynamicEditForm/DynamicEditForm";
import { getStoredData } from "../../json/fecthData";

const UserManagementEdit = () => {
  // Fetch stored user data
  const userData = getStoredData()?.[1] || {}; // Ensure userData is an object

  return (
    <div>
      <h2>Edit {userData.TitleUser} Management</h2>
      <DynamicEditForm
        fields={userData.AdminUser} // Pass dynamic fields
        apiUrl={userData.ApiUser} // Use correct API URL
        successRedirect={userData.RedirectAdminUser} // Redirect after successful update
      />
    </div>
  );
};

export default UserManagementEdit;
